import { render, staticRenderFns } from "./StaffSet.vue?vue&type=template&id=7ec10630&scoped=true&"
import script from "./StaffSet.vue?vue&type=script&lang=js&"
export * from "./StaffSet.vue?vue&type=script&lang=js&"
import style0 from "./StaffSet.vue?vue&type=style&index=0&id=7ec10630&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec10630",
  null
  
)

export default component.exports